import React from "react";
import { View } from "react-native";

import MapView from "./MapView";

type Props = {
  headerHeight: number;
  longitude?: Maybe<number>;
  latitude?: Maybe<number>;
};

const MapViewHeader = ({ headerHeight, longitude, latitude }: Props) => (
  <View style={{ height: headerHeight }}>
    <MapView latitude={latitude} longitude={longitude} />
  </View>
);

export default React.memo(MapViewHeader);
